module.exports = __webpack_public_path__ + "media/pdf/smp/Muster_Bonitaetspruefung_vor_Abschluss_eines_Mietvertrages-f967a6335544517bb8b504cc51f747e5.pdf";